import { getJson, postJson } from '@/lib/apiClient';
import type {
  Asset,
  AssetSearchResponse,
  GlossaryTerm,
  PendingEnrichment,
} from '@/features/catalog/types';

interface Wrapped<T> {
  data: T;
}

export interface EnrichmentFilters {
  asset_fqn?: string;
  status?: string;
}

export const catalogApi = {
  search: (q: string, from = 0, size = 20): Promise<AssetSearchResponse> =>
    getJson<AssetSearchResponse>('/catalog/search', { q, from, size }),

  asset: (fqn: string): Promise<Asset> =>
    getJson<Wrapped<Asset>>('/catalog/asset', { fqn }).then((r) => r.data),

  glossary: (): Promise<GlossaryTerm[]> =>
    getJson<Wrapped<GlossaryTerm[]>>('/catalog/glossary').then((r) => r.data),

  enrichments: (filters: EnrichmentFilters): Promise<PendingEnrichment[]> =>
    getJson<Wrapped<PendingEnrichment[]>>('/catalog/enrichments', {
      asset_fqn: filters.asset_fqn,
      status: filters.status,
    }).then((r) => r.data),

  generate: (assetFqn: string, maxSuggestions?: number): Promise<PendingEnrichment[]> =>
    postJson<Wrapped<PendingEnrichment[]>>('/catalog/enrichments', {
      asset_fqn: assetFqn,
      max_suggestions: maxSuggestions,
    }).then((r) => r.data),

  approve: (id: string): Promise<PendingEnrichment> =>
    postJson<Wrapped<PendingEnrichment>>(`/catalog/enrichments/${id}/approve`).then((r) => r.data),

  reject: (id: string): Promise<PendingEnrichment> =>
    postJson<Wrapped<PendingEnrichment>>(`/catalog/enrichments/${id}/reject`).then((r) => r.data),
};

export const catalogKeys = {
  search: (q: string) => ['catalog', 'search', q] as const,
  asset: (fqn: string) => ['catalog', 'asset', fqn] as const,
  glossary: ['catalog', 'glossary'] as const,
  enrichments: (filters: EnrichmentFilters) => ['catalog', 'enrichments', filters] as const,
};
